import React, { useEffect, useState, useRef } from 'react';

import './XRRecordingManager.css';
export default function XRRecordingManager(props) {

  const [XRRecordings, setXRRecordings] = useState([]);
  const [editedSets, setEditedSets] = useState({});
  const [previews, setPreviews] = useState({});
  const [paths, setPaths] = useState({});
  const [preventChange, setPreventChange] = useState(false);

  const [downloadState, setDownloadState] = useState({}); // recordingId: {state: 'processing', 'download' ,'error', 'ready'}
  const [downloadProgress, setDownloadProgress] = useState(null);

  useEffect(() => {
      props.deviceLinkSocket.on('link_message', processLinkMessage);
      updateXRRecordings();

      return () => {
          props.deviceLinkSocket.off('link_message', processLinkMessage);
      }
  }, [])

  useEffect(() => {
    updateXRRecordings();
  }, [props])


  function updateXRRecordings() {
      setPreviews({});
      props.deviceLinkSocket.emit('link_message', {
          token: props.device.token,
          msg: {
                  type: 'get_xrrecordings'
          }
      });
  }

  function processLinkMessage({from, msg}) {
    if (from !== props.device.id || !("type" in msg)) return;
    
    if (msg.type === 'xrrecordings') {
      setXRRecordings(msg.recordings);
      const structurePath = 'test;test1;test2';
      const setsDescriptionsValue = {};
      const recordingsToSave = [];
      msg.recordings.forEach((element, index) => {
        recordingsToSave.push(element);
        recordingsToSave[index].StructurePath = structurePath;
        setsDescriptionsValue[element.Id] = { Description: element.Description }
        deseralizePath(structurePath, [], element.Id);
      });
      setXRRecordings(recordingsToSave);
      setEditedSets(setsDescriptionsValue);


      if (Object.keys(previews).length == 0) {
        props.deviceLinkSocket.emit('link_message', {
          token: props.device.token,
          msg: {
            type: 'get_xrrecording_previews'
          }
        });
      }
    }
    else if (msg.type === 'xrrecording-previews') {
      setPreviews(msg.previews);
    }else if(msg.type === 'xrrecording_download_url'){
      const {id, fileName, url} = msg;

      console.log(`Downloaded URL for recording ${id}: ${url}`);

      downloadRecording(id, fileName, url);
    }else if(msg.type === 'xrrecording_download_error'){
      const {id, message} = msg;

      console.error(`Error during download ${id} : ${message}`);
      
      setDownloadState(prev => ({...prev, [id]: 'error'}));
    }else if(msg.type === "xrrecording_progress"){
      const {id, progress} = msg;

      console.log(`Downloading ${id}: ${progress}%`);

      setDownloadState(prev => ({...prev, [id]: 'downloading'}));
      setDownloadProgress(prev => ({...prev, [id]: progress}) );
    }
  }

  function setXRRecording(recordingID) {
    props.deviceLinkSocket.emit('link_message', {
      token: props.device.token,
      msg: {
        type: 'set_xrrecording',
        xrrecording: Object.assign({Id: recordingID}, editedSets[recordingID] || {})
      }
    });
  }

  function deleteXRRecording(recordingID) {
    props.deviceLinkSocket.emit('link_message', {
      token: props.device.token,
      msg: {
        type: 'delete_xrrecording',
        xrrecording: {Id: recordingID}
      }
    });
  }

  function saveEdit(xrrecording) {
    setXRRecording(xrrecording.Id);
  } 

  function deseralizePath(itemDirectory, pathArray, recordingID) {
    if (pathArray.length === 0 && itemDirectory === '') {
      setPaths(oldPaths => {
        let prev = {...oldPaths};
        prev[recordingID] = [''];
        return prev;
      })
    }else {
      let firstSeparatorIndex = itemDirectory.indexOf(';');
      let pathElement;
      if (firstSeparatorIndex < 0) {
        pathElement = itemDirectory;
      }else {
        pathElement = itemDirectory.substring(0, firstSeparatorIndex);
      }
      if (pathElement !== '') {
        if (pathArray.length === 0 && firstSeparatorIndex < 0) {
          pathArray = [pathElement, ''];
        }else if (pathArray.length === 0 && firstSeparatorIndex >= 0) {
          pathArray = new Array(pathElement);
        }else if (firstSeparatorIndex >= 0) {
          pathArray = [...pathArray, pathElement];
        }else {
          pathArray = [...pathArray, pathElement, ''];
        }
      } 
      if (firstSeparatorIndex >= 0) {
        deseralizePath(itemDirectory.substring(firstSeparatorIndex+1), pathArray, recordingID);
      }else {
        setPaths(oldPaths => {
          let prev = {...oldPaths};
          prev[recordingID] = pathArray;
          return prev;
        })
      }
    }
  }

  function serializePath(pathArray) {
    return pathArray.join(';').replace(/^;+/, '').replace(/;+$/, '');
  }

  function setName(recordingID, name) {
    setEditedSets((prev) => {
      let prevEditedSets = {...prev} || {};
      prevEditedSets[recordingID].Description = name;
      return prevEditedSets;
    });
  }


  function setPathDirectory(recordingID, index, value) {
    if (preventChange) {
      setPreventChange(false);
    }else {
      if (value.includes(';')) {
        let pathsToSerialize = paths[recordingID];
        pathsToSerialize[index] = value;
        deseralizePath(serializePath(pathsToSerialize), [], recordingID);
      }else {
        setPaths(oldPaths => {
          let prevPaths = {...oldPaths};
          if (prevPaths[recordingID][index] === '' && value !== '' && index === prevPaths[recordingID].length - 1) {
            prevPaths[recordingID].push('');
          } 
          prevPaths[recordingID][index] = value;
          return prevPaths;
        })
      }
    }
  }

  function savePath(index, path) {
    //Add socket emit
    setXRRecordings(oldRecs => {
      let prevRecs = [...oldRecs];
      prevRecs[index].StructurePath = path;
      return prevRecs; 
    })
  }

  function keyPressHandlerUp(key, recordingID, value, index) {
    if (key === "Enter" && paths[recordingID].length-1 !== index) {
      document.getElementById(recordingID+Number(index+1)).focus();
    }else if (key === "Delete") {
      let pathsToSerialize = paths[recordingID];
      pathsToSerialize[index] = '';
      deseralizePath(serializePath(pathsToSerialize), [], recordingID);
    }
  }

  function keyPressHandlerDown(key, recordingID, value, index) {
    if (key === "Backspace") {
      if  (paths[recordingID][index] === '' && value === ''){
        deseralizePath(serializePath(paths[recordingID]), [], recordingID);
        setPreventChange(true);
        if (index > 0) document.getElementById(recordingID+Number(index-1)).focus();
      }
    }
  }

  function handleDownloadClick(recordingId, isStatic, downloadUrl){
    setDownloadState(prev => ({...prev, [recordingId]: 'processing'}));

    if(isStatic && downloadUrl){
      // means it is already uploaded to the cloud, we can download it directly
      createLinkElement(recordingId, `${recordingId}.rxr`, downloadUrl);
      return;
    }

    if(downloadUrl){
      // means it was uploaded to the cloud, but its not static, so it doesn't have direct url
      downloadRecording(recordingId, `${recordingId}.rxr`, downloadUrl);

      return;
    }


    props.deviceLinkSocket.emit('link_message', {
      token: props.device.token,
      msg: {
        type: 'download_xrrecording',
        xrrecording: {Id: recordingId}
      }
    });
    
    console.log("Requesting download for recording:", recordingId);
  }

  async function downloadRecording(recordingId, fileName, url){
    try{
      const response = await fetch(url);
      const json = await response.json();

      const { dataurl } = json;

      createLinkElement(recordingId, fileName, dataurl);

      // update the xrrecordings list with new url
      setXRRecordings(prev => 
        prev.map(recording => 
          recording.Id === recordingId ? {...recording, Url: url} : recording
        )
      );
    }catch(error){
      console.error("Error downloading recording:", error);

      setDownloadState(prev => ({...prev, [recordingId]: 'error'}));
    }
  }

  async function createLinkElement(recordingId, fileName, url) {
    try {
      try{
        // using fetch + blob is the solution to download the file without reloading the page and without causing issues with deviceLinkSocket
        const response = await fetch(url);
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = blobUrl;
        link.setAttribute("download", fileName);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(blobUrl);
      }catch(error){
        // if fetch + blob fails due to CORS issues
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';

        iframe.onload = () => {
          document.body.removeChild(iframe);
        }

        iframe.onerror = () => {
          document.body.removeChild(iframe);
        }

        document.body.appendChild(iframe);
        iframe.src = url;
      }
    } catch (err) {
      console.error("Download failed:", err);
    }finally {
      setDownloadState(prev => ({...prev, [recordingId]: 'ready'}));
    }
  }

  return <div>
      {
          !props.device.online &&
              'Your device is offline. Please run Medicalholodeck on your device.'
      }
      { 
          props.device.online && editedSets &&
          (XRRecordings || []).map((XRRecording, recordingIndex) => {
            let editedSetsLocal = editedSets || {};
            let label = editedSetsLocal[XRRecording.Id] !== undefined ? editedSetsLocal[XRRecording.Id].Description : XRRecording.Description;
            let shownDescription = XRRecording.Id in editedSetsLocal ? editedSetsLocal[XRRecording.Id].Description : (XRRecording.Description || "");
            let path = paths[XRRecording.Id] || [''];
            return <div className="recordXR title-panel" key={XRRecording.Id}>
              <div className="data-preview-image" style={{
                backgroundImage: `url(data:image/png;base64,${previews[XRRecording.Id]})`}}>
              </div>
              <div className='metadata'>
                <h3>{(XRRecording.Description || "") === "" ? `#${XRRecording.RecordingIndex}` : XRRecording.Description}</h3>
                { new Date(Number(XRRecording.Time)*1000).toLocaleDateString() }
                <br />
                { Math.floor(XRRecording.Duration/60) < 10 ? '0' + Math.floor(XRRecording.Duration/60) : Math.floor(XRRecording.Duration/60)}:{ Math.floor(XRRecording.Duration%60) < 10 ? '0' + Math.floor(XRRecording.Duration%60) : Math.floor(XRRecording.Duration%60)}
              </div>
{/*               <div className="inputPath">
                <label>Path</label>
                <div style={{ display: 'block', marginTop: '5px'}}>
                  <div style={{ float: 'left', padding: '5px 0 5px 5px', height: '16px'}}>/</div>
                </div>
                {path.map((pathElement, index) => {
                  return <div className="pathElement" key={XRRecording.Id + index}>
                    <input id={XRRecording.Id + index} style={{width: (pathElement.length + 1) + 'ch'}} type="text" value={pathElement} 
                      onChange={(e) => setPathDirectory(XRRecording.Id, index, e.target.value)} onKeyUp={(e) => { keyPressHandlerUp(e.key, XRRecording.Id, e.target.value, index); }} onKeyDown={(e) => { keyPressHandlerDown(e.key, XRRecording.Id, e.target.value, index); }}/>
                    <div style={{ color: index === path.length-1 ? '#80808075' : 'black', paddingRight: index === path.length-1 ? '5px' : '0'}}>/</div>
                  </div>
                })}
                {serializePath(path) !== XRRecording.StructurePath && 
                <div className="pathButtons">
                  <button onClick={e => savePath(recordingIndex, serializePath(path))}>Save</button>
                  <button onClick={e => deseralizePath(XRRecording.StructurePath, [], XRRecording.Id)}>Cancel</button>
                </div>}
              </div> */}
              <div className="input">
                <label>Label</label><input style={{maxWidth:'300px'}} type="text" value={ label} onChange={e => setName(XRRecording.Id, e.target.value)} />
                {shownDescription != XRRecording.Description && <button onClick={() => saveEdit(XRRecording)}>Save</button>}
                {shownDescription != XRRecording.Description && <button onClick={() => setName(XRRecording.Id, XRRecording.Description)}>Cancel</button>}
              </div>
              <div className="interactions-container">
                <div className="download-container">
                  {downloadState[XRRecording.Id] === 'error' && <span className="error">Something went wrong. Try again.</span>}
                    {!downloadState[XRRecording.Id] || downloadState[XRRecording.Id] === 'ready' || downloadState[XRRecording.Id] === 'error' ? 
                      <button className="download has-progress-bar" onClick={() => handleDownloadClick(XRRecording.Id, XRRecording.IsStatic, XRRecording.Url)}>
                        Download
                    </button> :
                    <div className={`downloading-progress-container ${downloadState[XRRecording.Id]}`}>
                      {downloadState[XRRecording.Id] === 'processing' && <>Processing<span className="loading-dots"></span></>}
                      {downloadState[XRRecording.Id] === 'downloading' && downloadProgress && 
                      <>
                        <div className="progress-text">{downloadProgress[XRRecording.Id]}%</div>
                        <div 
                          className="progress-fill" 
                          style={{ width: `${downloadProgress[XRRecording.Id]}%` }}>
                        </div>
                      </>
                      }
                    </div>
                    }
                </div>
                
                <div className="delete">
                  <button onClick={() => deleteXRRecording(XRRecording.Id)}>Delete</button>
                </div>
              </div>
            </div>
          }).reverse()
      }
  </div>
} 